"use client";

import React from "react";
import { MessageCircle, Phone, CircleCheck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StartYourRenovation() {
  return <section id="start-your-renovation" className="bg-secondary text-secondary-foreground py-20 lg:py-28 overflow-hidden relative !bg-[url(https://simprotile.com/wp-content/uploads/2026/03/20240516_191544-scaled.jpg)]">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-secondary-foreground/5 skew-x-12 pointer-events-none" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl font-bold tracking-tight !text-[hsl(0,0%,0%)] md:text-5xl">
                Start Your Renovation
              </h2>
              <p className="text-lg max-w-lg leading-relaxed !text-[hsl(0,0%,0%)] md:text-xl">
                Ready to transform your bathroom or wet room? Get a free, no-obligation quote from London's tiling specialists.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <Link to="https://wa.me/447467562688" newTab className="group relative inline-flex items-center justify-center gap-3 bg-white text-secondary px-8 py-4 text-lg font-bold shadow-2xl hover:shadow-xl hover:-translate-y-1 transition-all duration-300 rounded-full sm:rounded-xl">
                <MessageCircle className="size-6 fill-secondary/20" />
                <span className="text-black">Chat on WhatsApp</span>
                <ArrowRight className="size-5 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
              </Link>

              <Link to="tel:+447467562688" className="inline-flex items-center justify-center gap-3 px-6 py-4 text-lg font-medium text-secondary-foreground transition-colors border border-secondary-foreground/20 rounded-xl !bg-[hsl(0,0%,100%)] hover:text-secondary-foreground/80 hover:border-secondary-foreground/40">
                <Phone className="size-5" />
                <span className="text-black">Call +447467562688</span>
              </Link>

              <Button asChild size="lg" className="bg-[#b7a147] text-black hover:bg-[#b7a147]/90 hover:shadow-[0_0_20px_rgba(183,161,71,0.4)] text-lg font-bold shadow-2xl hover:-translate-y-1 transition-all duration-300 rounded-sm h-auto px-8 py-4 w-full">
                <Link to="/get-a-quote" aria-label="Fast quotation">
                  Fast Quotation
                </Link>
              </Button>
            </div>

            <div className="pt-8 border-t border-secondary-foreground/10">
              <p className="text-sm font-medium text-black mb-4">Why choose SimProTiling?</p>
              <ul className="grid sm:grid-cols-2 gap-3">
                {["11+ Years Experience", "Luxury Finishes", "Free Consultation", "Fully Insured"].map((item, i) => <li key={i} data-index={i} className="flex items-center gap-2 text-secondary-foreground/90">
                    <CircleCheck className="size-4 text-primary" />
                    <span className="text-black">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}